import React from "react";
import DropdownField from "../formik/dropdown";
import TextInputField from "../formik/text-input";
import { CancelReasonModel, CancelReasonOptionsData } from "./types";
import Button from "../../../../ui/widgets/button";
import { Form, Formik } from "formik";
import { useMessageSource } from "react-message-source";
import InputContainer from "../../../../ui/layout/page/forms-container/form-item-container/input-container";
import useCancelReasonValidator from "./cancel-validator";
import { CancellationCase } from "../../../../context/cancelApplicationContext";
import GridContainer from "../../../../ui/layout/page/container/GridContainer";
import FormFullWidthContainer from "../../../../ui/layout/page/forms-container/form-full-width-container";

export const getCancelReasonOptionsData = (
  getMessage: (key: string, ...params: unknown[]) => string,
): CancelReasonOptionsData => {
  const dynamicReasonsKey =
    "CancelApplication.cancel-reason.CancelReasonOptionValue.dynamic-reasons";

  const cancelReasonOptionsRawText =
    getMessage(dynamicReasonsKey) === dynamicReasonsKey
      ? ""
      : getMessage(dynamicReasonsKey);

  const cancelReasonOptionsRawObject: { key: string; translation: string }[] =
    JSON.parse(`{"reasons": [${cancelReasonOptionsRawText}]}`)?.reasons;

  const cancelReasonOptions = cancelReasonOptionsRawObject.map(
    ({ key, translation }) => {
      return {
        value: key,
        children: translation,
      };
    },
  );

  const cancelReasonOptionOtherValue = cancelReasonOptions.slice(-1)[0]?.value;

  return {
    cancelReasonOptions: cancelReasonOptions,
    cancelReasonOptionOtherValue: cancelReasonOptionOtherValue,
  };
};

const CancelReason = ({
  cancellationCase,
  cancelApplicationCallback,
}: {
  cancellationCase: CancellationCase;
  cancelApplicationCallback: (values: CancelReasonModel) => void;
}): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const cancelButtonKey =
    cancellationCase === CancellationCase.ADDITIONAL_CA
      ? "CancelApplication.card-application.button"
      : "CancelApplication.basic-account-application.cancel.button";

  const { cancelReasonOptions, cancelReasonOptionOtherValue } =
    getCancelReasonOptionsData(getMessage);

  const shouldShowCancelReasonOption =
    cancellationCase !== CancellationCase.NOT_PERSISTED;
  const initialValues: CancelReasonModel = {
    cancelReasonOption: null,
    otherReason: null,
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => cancelApplicationCallback(values)}
      validationSchema={useCancelReasonValidator()}
    >
      {({ handleSubmit, isSubmitting, values }) => {
        return (
          <Form>
            {shouldShowCancelReasonOption && (
              <GridContainer sx={{ width: { lg: "50%" } }}>
                <FormFullWidthContainer container={false}>
                  <DropdownField
                    name={"cancelReasonOption"}
                    menuItems={cancelReasonOptions}
                    selectedItemValue={values.cancelReasonOption}
                    label={getMessage(
                      "CancelApplication.cancel-reason.CancelReasonOptions.label",
                    )}
                  />
                </FormFullWidthContainer>
                {values?.cancelReasonOption ===
                  cancelReasonOptionOtherValue && (
                  <InputContainer>
                    <TextInputField
                      name={"otherReason"}
                      label={getMessage(
                        "CancelApplication.cancel-reason.CancelReasonOptions.reason-other.label",
                      )}
                      value={values.otherReason}
                    />
                  </InputContainer>
                )}
              </GridContainer>
            )}
            <div className="scd-dialog-footer">
              <Button
                kind="primary"
                onClick={() => handleSubmit()}
                disabled={isSubmitting}
              >
                {getMessage(cancelButtonKey)}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CancelReason;
